import React, { useId } from 'react'

const AirModeIcon = (props) => {
    const gradientId = useId();

    return (
        <svg
            width={props?.width ? props?.width : 34}
            height={props?.height ? props?.height : 21}
            viewBox="0 0 512 318"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.922 44.324H0L28.219 125.4C28.4304 125.993 28.5714 126.609 28.639 127.235L33.351 167.779C39.059 169.02 45.0057 170.32 51.191 171.679C84.23 178.92 125.091 187.873 168.18 195.911L187.153 167.344C188.003 166.07 189.177 165.046 190.554 164.376C191.931 163.707 193.461 163.415 194.988 163.533L308.972 172.439C310.628 172.564 312.212 173.166 313.532 174.173C314.852 175.179 315.852 176.547 316.411 178.111C316.969 179.674 317.062 181.366 316.679 182.982C316.295 184.597 315.452 186.066 314.25 187.212L286.519 213.756C376.37 223.284 443.848 219.02 487.312 201.038C503.189 194.463 512.19 187.222 512.001 181.156C511.878 177.556 508.251 166.905 475.377 150.773C475.334 153.713 474.667 156.61 473.42 159.273C469.34 167.948 459.839 173.217 444.372 175.368C443.976 175.423 443.577 175.45 443.178 175.448H412.319C411.183 175.46 410.056 175.247 409.003 174.821C407.951 174.395 406.993 173.764 406.185 172.965C405.378 172.166 404.737 171.215 404.299 170.167C403.862 169.119 403.636 167.994 403.636 166.858C403.636 165.723 403.862 164.598 404.299 163.55C404.737 162.502 405.378 161.551 406.185 160.752C406.993 159.953 407.951 159.322 409.003 158.896C410.056 158.47 411.183 158.257 412.319 158.269H442.57C454.849 156.462 457.391 152.99 457.87 151.957C458.781 150.032 457.88 146.357 455.47 141.877C446.39 138.155 435.88 134.202 423.681 130.041C398.219 121.168 256.597 124.876 171.991 127.089C141.91 127.876 115.937 128.551 100.64 128.589H100.612C99.1842 128.588 97.7791 128.232 96.5232 127.553C95.2674 126.873 94.2002 125.892 93.418 124.698L40.918 44.332L40.922 44.324ZM186.511 5.93201L227.011 0.38501L305.037 107.285C283.348 107.446 259.861 107.833 235.299 108.361L186.511 5.93201ZM153.142 317.62L114.033 308.42L198.681 181.058L288.49 188.072L153.142 317.62Z"
                fill={`url(#${gradientId})`}
            />
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="256.002"
                    y1="317.62"
                    x2="256.003"
                    y2="0.385004"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6C54A3" />
                    <stop offset={1} stopColor="#00B1D2" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default AirModeIcon;
